export default __webpack_public_path__ + "static/media/new-born.934174b8.svg";